<div class="iad-panel" *ngIf="row">
  <section class="iad-card">
    <div class="iad-card__header">
      <span class="iad-card__title"><mat-icon>{{ type === 2 ? 'business' : 'class' }}</mat-icon> {{ row.description || 'Inversión' }}</span>
      <app-status-pill [label]="paymentLabel" [variant]="paymentVariant"></app-status-pill>
    </div>

    <div class="iad-progress">
      <div class="iad-progress__bar">
        <div class="iad-progress__fill" [style.width.%]="paidPercent"></div>
      </div>
      <div class="iad-progress__legend">
        <span>Pagado <strong>{{ row.paid | number:'1.2-2' }} €</strong></span>
        <span>Pendiente <strong>{{ pendingAmount | number:'1.2-2' }} €</strong></span>
        <span>Total <strong>{{ row.total | number:'1.2-2' }} €</strong></span>
      </div>
    </div>

    <div class="iad-kpis">
      <div class="iad-kpi">
        <span class="iad-kpi__label">Total sin impuestos</span>
        <span class="iad-kpi__value">{{ row.totalWithoutTax | number:'1.2-2' }} €</span>
      </div>
      <div class="iad-kpi">
        <span class="iad-kpi__label">Impuestos</span>
        <span class="iad-kpi__value">{{ row.totalTax | number:'1.2-2' }} €</span>
      </div>
      <div class="iad-kpi">
        <span class="iad-kpi__label">Coeficiente lineal</span>
        <span class="iad-kpi__value">{{ row.maximumLinealCoeficient | number:'1.0-2' }} %</span>
      </div>
      <div class="iad-kpi">
        <span class="iad-kpi__label">Periodo máximo</span>
        <span class="iad-kpi__value">{{ row.maximumPeriod | number:'1.0-2' }} años</span>
      </div>
      <div class="iad-kpi">
        <span class="iad-kpi__label">Amortización {{ year }}</span>
        <span class="iad-kpi__value"><app-status-pill [label]="amortisationLabel" [variant]="amortisationVariant"></app-status-pill></span>
      </div>
      <div class="iad-kpi">
        <span class="iad-kpi__label">Tipo</span>
        <span class="iad-kpi__value">{{ row.typeInvestment || '—' }}</span>
      </div>
    </div>

    <div class="iad-kpis iad-kpis--compact" *ngIf="!loading && !error">
      <div class="iad-kpi iad-kpi--accent">
        <span class="iad-kpi__label">Cuadro {{ year }}</span>
        <span class="iad-kpi__value">{{ amortizedYear | number:'1.2-2' }} €</span>
      </div>
      <div class="iad-kpi">
        <span class="iad-kpi__label">Amortizado hasta hoy</span>
        <span class="iad-kpi__value">{{ amortized | number:'1.2-2' }} €</span>
      </div>
      <div class="iad-kpi">
        <span class="iad-kpi__label">Pendiente de amortizar</span>
        <span class="iad-kpi__value">{{ pendingAmortization | number:'1.2-2' }} €</span>
      </div>
    </div>

    <div class="iad-lines">
      <div class="iad-line">
        <span class="iad-line__label">Cuenta</span>
        <span class="iad-line__value">{{ row.account || '—' }}</span>
      </div>
      <div class="iad-line">
        <span class="iad-line__label">Proveedor</span>
        <span class="iad-line__value">{{ row.supplier || '—' }}</span>
      </div>
      <div class="iad-line">
        <span class="iad-line__label">Fecha de compra</span>
        <span class="iad-line__value">{{ date(row.purchaseDate) }}</span>
      </div>
      <div class="iad-line">
        <span class="iad-line__label">Puesta en funcionamiento</span>
        <span class="iad-line__value">{{ date(row.startWorkingDate) }}</span>
      </div>
      <div class="iad-line" *ngIf="hasDocument">
        <span class="iad-line__label">Documento</span>
        <span class="iad-line__value">{{ row.pdf ? 'PDF adjunto' : 'Imagen adjunta' }}</span>
      </div>
    </div>

    <div class="iad-actions">
      <button mat-stroked-button class="cf-btn" (click)="openSchedule()">
        <mat-icon>insert_chart</mat-icon> Cuadro de amortización
      </button>
      <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="edit.emit()">
        <mat-icon>edit</mat-icon> Editar inversión
      </button>
    </div>
  </section>

  <section class="iad-card">
    <div class="iad-card__header">
      <span class="iad-card__title"><mat-icon>date_range</mat-icon> Operaciones</span>
    </div>

    <app-loading-state *ngIf="loading" [compact]="true" message="Cargando operaciones…"></app-loading-state>

    <div class="iad-empty iad-empty--error" *ngIf="!loading && error">
      <mat-icon>error</mat-icon>
      <span>No se pudieron cargar las operaciones de la inversión.</span>
      <button mat-stroked-button class="cf-btn" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>

    <ng-container *ngIf="!loading && !error">
      <div class="iad-block" *ngFor="let block of blocks; trackBy: trackByKind">
        <div class="iad-block__header">
          <span class="iad-block__title"><mat-icon>{{ block.icon }}</mat-icon> {{ block.title }}</span>
          <span class="iad-block__side">
            <span class="iad-block__summary" *ngIf="block.count > 0">
              {{ block.count }} · <strong>{{ block.total | number:'1.2-2' }} €</strong>
            </span>
            <button *ngIf="block.canAdd" mat-stroked-button type="button" class="cf-btn cf-btn--primary iad-add" (click)="add(block)">
              <mat-icon>{{ block.kind === 'schedule' ? 'insert_chart' : 'add' }}</mat-icon> {{ block.addLabel }}
            </button>
          </span>
        </div>

        <div class="iad-moves" *ngIf="block.lines.length">
          <div class="iad-move" *ngFor="let line of block.lines; trackBy: trackByKey" [class.iad-move--schedule]="block.kind === 'schedule'">
            <span class="iad-move__date" *ngIf="block.kind !== 'schedule'">{{ date(line.date) }}</span>
            <span class="iad-move__info">
              <span class="iad-move__concept" [title]="line.concept">{{ line.concept }}</span>
              <span class="iad-move__meta" *ngIf="line.meta" [title]="line.meta">{{ line.meta }}</span>
            </span>
            <span class="iad-move__amount">{{ line.amount | number:'1.2-2' }} €</span>
            <span class="iad-move__actions" *ngIf="block.canEdit || block.canDelete">
              <button *ngIf="block.canEdit" type="button" class="iad-icon-btn" (click)="editLine(block, line)" title="Editar" aria-label="Editar">
                <mat-icon>edit</mat-icon>
              </button>
              <button *ngIf="block.canDelete" type="button" class="iad-icon-btn iad-icon-btn--danger" (click)="deleteLine(block, line)" title="Eliminar" aria-label="Eliminar">
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </div>
          <button type="button" class="iad-more" *ngIf="block.count > maxLines" (click)="manage(block)">
            Ver los {{ block.count }} {{ block.moreLabel }} <mat-icon>chevron_right</mat-icon>
          </button>
        </div>

        <div class="iad-block__empty" *ngIf="!block.lines.length">{{ block.emptyText }}</div>
      </div>
    </ng-container>
  </section>
</div>
